import(/* webpackMode: "eager" */ "/app/apps/web/app/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebVitals"] */ "/app/apps/web/components/WebVitals.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.4_@babel+core@7.26.7_@opentelemetry+api@1.8.0_@playwright+test@1.48.2_babel-plugin-_kxbk52bfyivyx4465i4twzmiwe/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Roboto\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"700\"],\"style\":[\"normal\",\"italic\"],\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"roboto\"}");
;
import(/* webpackMode: "eager" */ "/app/apps/web/styles/app-dir.css");
;
import(/* webpackMode: "eager" */ "/app/apps/web/styles/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["ReactQueryAppContext"] */ "/app/packages/common-nextjs/src/react-query/ReactQueryAppContext.tsx");
